/**
 * Semantic tones used by badges, alerts and status labels. Feature code maps its own statuses
 * (job "open", milestone "funded", ...) to one of these, so colours stay consistent everywhere.
 */
export type Tone = 'neutral' | 'brand' | 'info' | 'success' | 'warning' | 'danger';

export const toneClasses: Record<Tone, string> = {
  neutral: 'bg-muted text-muted-foreground border-border',
  brand: 'bg-primary/15 text-foreground border-primary/40',
  info: 'bg-info/10 text-info border-info/30',
  success: 'bg-success/10 text-success border-success/30',
  warning: 'bg-warning/15 text-warning-strong border-warning/40',
  danger: 'bg-danger/10 text-danger border-danger/30',
};
